import { useCallback, useState } from 'react';

import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { useScurveStore } from 'store/scurve.store';

export const useAnnotationToggle = (widgetViewMode: WidgetViewMode, initialValue?: boolean) => {
    const isPageView = WidgetViewModeUtils.isPageView(widgetViewMode);
    // Page view: shared global state
    const storeValue = useScurveStore((s) => s.isShowCriticalityAnnotation);
    const storeUpdate = useScurveStore((s) => s.update);
    // Report view: isolated per-widget state
    const [localValue, setLocalValue] = useState<boolean>(initialValue ?? false);
    const value = isPageView ? storeValue : localValue;
    const setValue = useCallback(
        (checked: boolean) => {
            if (isPageView) {
                storeUpdate({ isShowCriticalityAnnotation: checked });
            } else {
                setLocalValue(checked);
            }
        },
        [isPageView, storeUpdate],
    );
    return [value, setValue] as const;
};
